<template>
  <DBox
    :id="'cmp-distribution-supplier-order-s_orderlines'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('')}`"
    @add_click="onAddClick"
  >
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="catalog-releases-artist"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('account_name')">
            <!-- <span @click="onArtistClicked(item)" class="ut-link ut-text-accent5">{{ item["artist_name"] }}</span> -->
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="false"
              :options="accountTV"
              :selected="accountTV.find(v => v.value == item.account_id)"
              :placeholder="$t('account_name')"
              v-on:selectedChange="e => onDropdownChange(item, e)"
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('notes')">
            <TextField2
              type="text"
              class="dbox1"
              id="notes"
              :showLabel="false"
              :disabled="false"
              :value="item['notes']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('qty')">
            <TextField2
              type="text"
              class="dbox1"
              id="order_qty"
              :showLabel="false"
              :disabled="false"
              :value="item['order_qty']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('shipped')">
            <span>{{item['shipped_qty']}}</span>
          </td>
          <!-- <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteOrderLine(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td> -->
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV, tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { catalogArtistListLDTRoutes } from '../../router/routes';
export default {
  props: {
    selectedSupplierOrderDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("account_name", {}),
        createTableHeader("notes", {}),
        createTableHeader("qty", {}),
        createTableHeader("shipped",{}),
        createTableHeader("option", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedSupplierOrderDetails.s_orderlines || [];
    },

    accountTV: function() {
      return createTV(this.selectedSupplierOrderDetails?.accounts||[],'account_name','account_id');
    }
  },
  methods: {
    onTextFieldChange: function(e, item) {
      const payload = {
        name: e.name,
        value: e.value,
        kVal:item.supplier_orderline_id,
        objKey:'s_orderlines'
        //item: item
      };
      this.$emit("change", payload);

      console.log("ARTIST", payload, e);
    },
    onDropdownChange: function(item, e) {
      const payload = {
        name: "account_id",
        value: e.value,
        kVal:item.supplier_orderline_id,
        objKey:'s_orderlines'
        //item: item
      };
      this.$emit("change", payload);
    },

    onAddClick: function() {
      this.$emit('add')
    },
    deleteOrderLine: async function(item) {
      const confirmationResult = await confirmDelete(
        this.$t("delete_orderline_msg"),
        ''
      );
      if (confirmationResult == "OK") {
        // const payload = { relation_id: item.relation_id };
        this.$emit("delete", {item,objKey:'s_orderlines' });
      }
    },
  }
};
</script>
